import T from 'prop-types'
import React from 'react'
import ReactDOM from 'react-dom'
import _ from 'lodash'
import cx from 'classnames'
import MenuOwner from './MenuOwner'
import ScrollBars from '../components/scrollbars/ScrollBars'
import TypeaheadOption from '../components/TypeaheadOption'
import fuzzaldrin from 'fuzzaldrin-plus'

const DEFAULT_OPTION_HEIGHT = 29
const MAX_FUZZY_RESULTS = 10
const OPT_REF_PREFIX = 'opt_'

export default class TypeaheadMenuOwner extends React.Component {
  static propTypes = {
    className: T.string,
    children: T.node,
    isMenuOpen: T.bool,
    closeMenu: T.func,

    preventAutoSelect: T.bool,
    filterString: T.string.isRequired,
    onApplyMenuOption: T.func.isRequired,
    options: T.array,

    alwaysSelectFirstOption: T.bool,
    optionHeight: T.number,
    omitExactMatch: T.bool,
    stopClickPropagation: T.bool,
    maxOptsToShow: T.number,
    menuClassName: T.string,
    noMatchesText: T.string,
    saveEmptyStrings: T.bool,
    activeOptionId: T.any,
    groupByHeadingText: T.bool
  }

  static defaultProps = {
    preventAutoSelect: false,
    filterString: '',
    optionHeight: DEFAULT_OPTION_HEIGHT,
    saveEmptyStrings: false,
    groupByHeadingText: false
  }

  constructor(props) {
    super(props)
    this.state = {
      fuzzyMatches: [],
      selectionIdx: -1
    }
  }

  UNSAFE_componentWillMount() {
    this._refs = {}
  }

  componentWillUnmount() {
    this._refs = {}
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    const {
      filterString,
      options,
      preventAutoSelect,
      omitExactMatch,
      isMenuOpen
    } = this.props
    if (
      !_.isEqual(nextProps.options, options)
      || nextProps.filterString !== filterString
      || nextProps.preventAutoSelect !== preventAutoSelect
      || nextProps.omitExactMatch !== omitExactMatch
    ) {
      this._filterOptions(nextProps)
    }
    if (isMenuOpen && !nextProps.isMenuOpen) {
      this.resetMenu()
    }
  }

  moveSelection = isUp => {
    const { optionHeight } = this.props
    const { selectionIdx } = this.state
    // if (!isMenuOpen) {
    //   // this.openMenu()
    //   // return
    // }
    const optHeight = optionHeight
    const _maxIndex = this._latestOptionCt - 1
    const _prevIdx = selectionIdx || 0
    let _toIndex = isUp ? _prevIdx - 1 : _prevIdx + 1
    if (_toIndex > _maxIndex) {
      _toIndex = 0 // loop back to beginning
    } else if (_toIndex < 0) {
      _toIndex = _maxIndex // loop to end
    }
    const _el = ReactDOM.findDOMNode(this._getOptionAtIndex(_toIndex))
    if (!_el) {
      return
    }
    this.setState({ selectionIdx: _toIndex })
    const _toOffset = _el.offsetTop
    // let _scrollerInst = this.getMenuRefs().listScroller
    const _scrollerInst = this._refs.scroller
    const _scrolledEl = _scrollerInst.getScrolledElement()
    const { scrollTop, offsetHeight } = _scrolledEl

    const scrollUpDistance = _toOffset - scrollTop
    const scrollDownDistance = _toOffset + optHeight - (offsetHeight + scrollTop)

    if (scrollUpDistance < 0 || scrollDownDistance > 0) {
      const isScrollUp = scrollUpDistance < 0
      const dist = isScrollUp ? scrollUpDistance : scrollDownDistance
      // If within 1 height units, just increment/decrement scroll by 1 unit
      if (Math.abs(dist) <= optHeight) {
        _scrollerInst.scrollTo(
          0,
          scrollTop - (isScrollUp ? optHeight : -optHeight)
        )
      } else {
        // Otherwise if distance is greater, jump directly to new position
        _scrollerInst.scrollTo(0, _toOffset - optHeight)
      }
    }
  }

  // Return <bool>optionApplied.
  selectOption = unmatchedValue => {
    if (this.state.selectionIdx > -1) {
      this._addOptionAtIndex(this.state.selectionIdx)
      return true
    } else if (unmatchedValue) {
      this.saveUnmatchedValue(unmatchedValue)
      return false
    }

    // if (this.state.selectionIdx === -1) {
    //   // No selection, add new
    // } else {
    // }
  }

  _filterOptions = (props = this.props) => {
    const { options, preventAutoSelect, omitExactMatch, filterString } = props
    if (filterString.length === 0) {
      this.resetMenu()
      return
    }
    // if (!isMenuOpen) {
    //   this.openMenu()
    // }
    const _options = omitExactMatch
      ? _.reject(options, { name: filterString })
      : options
    const _matches = fuzzaldrin.filter(_options, filterString, {
      key: 'name',
      maxResults: MAX_FUZZY_RESULTS
    }).map(result => {
      result.similarity = fuzzaldrin.score(result.name, filterString)
      return result
    })
    this.setState({
      fuzzyMatches: _.sortBy(_matches, 'similarity'),
      selectionIdx: _matches.length > 0 && !preventAutoSelect ? 0 : -1 // Pre-select first result
    })
  }

  /**
   * Save an input string that did not match any of the provided state.options
   */
  saveUnmatchedValue = (unmatchedValue = '') => {
    const {
      saveEmptyStrings
    } = this.props
    const _value = unmatchedValue.trim()
    if (saveEmptyStrings || _value !== '') {
      this._applyOption({ name: _value }, true)
    }
  }

  _getOptionAtIndex = index => {
    return this._refs ? this._refs[OPT_REF_PREFIX + index] : null
  }

  _addOptionAtIndex = index => {
    const _optionEl = this._getOptionAtIndex(index)
    if (_optionEl) {
      this._applyOption(_optionEl.props.option, false)
    }
  }

  _onOptionClick = option => {
    this._applyOption(option, false)
  }

  _applyOption = (option, isNew = false) => {
    const { onApplyMenuOption } = this.props
    const optionValue = _.assign(option, { isNew })
    if (!onApplyMenuOption || !_.isFunction(onApplyMenuOption)) {
      console.error(
        'TypeaheadMenuOwner requires owner to provide an onApplyMenuOption function'
      )
    }
    onApplyMenuOption(optionValue)
  }

  getMenuRef = () => {
    this._refs.menu
  }

  resetMenu = () => {
    const { preventAutoSelect, alwaysSelectFirstOption, options } = this.props
    const autoSelect =
      !preventAutoSelect && alwaysSelectFirstOption && options.length > 0
    this.setState({
      fuzzyMatches: [],
      selectionIdx: autoSelect ? 0 : -1
    })
  }

  _bindScrollerRef = scroller => {
    this._refs.scroller = scroller
  }

  _bindMenuRef = menu => {
    this._refs.menu = menu
  }

  _bindOptionRef = (index, el) => {
    this._refs[OPT_REF_PREFIX + index] = el
  }

  _renderMenu = () => {
    const {
      isMenuOpen,
      filterString,
      options,
      optionHeight,
      maxOptsToShow,
      menuClassName,
      noMatchesText,
      stopClickPropagation,
      activeOptionId
      // groupByHeadingText
    } = this.props
    const { fuzzyMatches, selectionIdx } = this.state
    if (!isMenuOpen) {
      return null
    }
    const _options =
      filterString !== ''
        ? _.sortBy(fuzzyMatches || [], option => -option.similarity)
        : options

    // if (groupByHeadingText) {
    //   _options = _.map(_options, (opt, i, allOpts) => {
    //     if (i === 0 ||) {

    //     }
    //   })
    // }

    const EXTRA_HEIGHT = 10

    this._latestOptionCt = _options.length
    const _newHeight =
      optionHeight *
        (this._latestOptionCt >= maxOptsToShow
          ? maxOptsToShow
          : this._latestOptionCt) +
      EXTRA_HEIGHT
    return _options.length === 0
      ? noMatchesText &&
        <div
          className={`no_typeahead_options_found ${menuClassName ||
            ''}`}
        >
          {noMatchesText}
        </div>
      : <div
          className={cx('typeahead_option_list', menuClassName)}
          style={{ height: _newHeight }}
        >
          <ScrollBars
            classes="pw_scrollbars_light"
            horizontal
            slimShady
            slimShadyDarker
            getRef={this._bindScrollerRef}
          >
            <ul>
              {_.map(_options, (option, i) =>
                <TypeaheadOption
                  key={option.id}
                  onClick={this._onOptionClick}
                  option={option}
                  query={filterString}
                  ref={_.partial(this._bindOptionRef, i)}
                  selected={selectionIdx === i}
                  stopClickPropagation={stopClickPropagation}
                  activeOptionId={activeOptionId}
                />
              )}
            </ul>
          </ScrollBars>
        </div>
  }

  render() {
    const { children, closeMenu } = this.props
    return (
      <MenuOwner
        {..._.omit(this.props, 'children')}
        onClose={closeMenu}
        renderMenu={this._renderMenu}
        getRef={this._bindMenuRef}
      >
        {children}
      </MenuOwner>
    )
  }
}
